import { render } from "./setting-blocked-user.vue?vue&type=template&id=4d8dd6f2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__